import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=285ec10e&scoped=true"
import script from "./feedBack.vue?vue&type=script&lang=ts"
export * from "./feedBack.vue?vue&type=script&lang=ts"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=285ec10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285ec10e",
  null
  
)

export default component.exports